
import { mdiChevronRight, mdiWeb } from "@mdi/js";

export default {
  name: "CContactLink",

  props: {
    title: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
    iconName: {
      type: String,
      default: "",
    },
  },

  computed: {
    isSocial() {
      return this.type === "social";
    },

    icon() {
      if (!this.iconName) return null;
      if (this.iconName === "Other") return null;
      return `IconSocial${this.iconName}`;
    },

    webIcon() {
      return this.iconName === "Other" ? this.mdiWeb : null;
    },

    chevronIcon() {
      return this.mdiChevronRight;
    },

    mdiWeb() {
      return mdiWeb;
    },

    mdiChevronRight() {
      return mdiChevronRight;
    },
  },

  methods: {
    onClick(e) {
      this.$emit("click", e);
    },
  },
};
